const AUTHENTICATION_URL = '/authentication';

export function authenticationApi() {
  return AUTHENTICATION_URL;
}

export function signInApi() {
  return `${AUTHENTICATION_URL}/log-in`;
}

export function signOutApi() {
  return `${AUTHENTICATION_URL}/log-out`;
}
